/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Table, Grid, Row, Col, FormGroup, ControlLabel, Button, Popover } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle';

import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';
import { PopoverForm } from "./PopoverForm";
import { SortHelper } from "../../helpers/SortHelper";

export class PassingTimesDraft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            viewAllSchedules: false
        }
    }

    toggleViewAllSchedules() {
        const { viewAllSchedules } = this.state;

        this.setState({
            viewAllSchedules: !viewAllSchedules
        });
    }

    renderPathStops(pathSelectedPathStops, tablePassings) {
        if (undefined === pathSelectedPathStops) {
            return null;
        }

        return (
            pathSelectedPathStops.map((stop, idx) =>
                <tr className="pst_tr_stops" key={`stop-${idx}`}>
                    <th className="pst_td_stops" title={stop.stopName}>[{stop.stopCode}] {stop.stopName}</th>
                    {tablePassings[stop.id]}
                </tr>
            )
        );
    }

    renderOptionsPopup(pt) {
        return (
            <Popover id="popover-trigger-focus" title="Opções">
                <Col xs={12}>
                    <div className="d-flex align-items-center justify-content-center">
                        <TableButton icon="icon-manage-uptime" title="Periodos de Funcionamento" onClick={() => this.props.handleIntervalsClick(pt)} />
                        <p>
                            Periodos de Funcionamento
                        </p>
                    </div>

                    <div className="d-flex align-items-center justify-content-center">
                        <TableButton icon="icon-lines" title="Notas" onClick={() => this.props.handleNotesClick(pt)} />
                        <p>
                            Notas
                        </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <TableButton icon="icon-network" title="Mover Viagem" onClick={() => this.props.handleMoveClick(pt)} />
                        <p>
                            Mover
                        </p>
                    </div>

                    <div className="d-flex align-items-center justify-content-center">
                        <TableButton icon="icon-copy" title="Copiar Viagem" onClick={() => this.props.handleCopyClick(pt)} />
                        <p>
                            Copiar
                        </p>
                    </div>
                </Col>
            </Popover>
        );
    }

    renderTable() {
        const { pathTrips, scheduleSelected } = this.props;

        if (undefined === pathTrips || undefined === scheduleSelected) {
            return null;
        }

        const { loadingTrips } = this.props;

        if (loadingTrips) {
            return (<LoadingSpinner />);
        }

        const { pathSelectedPathStops, editTripName, selectedPassing } = this.props;
        const tablePathTrips = [];
        const tablePassings = {};

        const closable = pathTrips.length > 0;
        let tabIndex = 10;
        pathTrips.forEach((pt, i) => {
            if (pt !== undefined) {
                if (pt.id > 0) {
                    if (pt.id === editTripName) {
                        tablePathTrips.push(
                            <th className="pst_th_trips" title={pt.code} key={`pathTrip-${i}`}>
                                {closable ? <a className="pst_a_delete" onClick={(e) => this.props.handleDeleteClick(pt, "draft")}>X</a> : null}
                                <input className="pst_input" type="text" value={pt.code} onChange={(e) => this.props.onChangeTripName(pt.id, e)} />
                            </th>
                        );
                    } else {
                        tablePathTrips.push(
                            <th className="pst_th_trips" title={pt.code} key={`pathTrip-${i}`}>
                                <PopoverForm
                                    pt={pt}
                                    handleIntervalsClick={(a) => this.props.handleIntervalsClick(a, "draft")}
                                    handleMoveClick={(a) => this.props.handleMoveClick(a, "draft")}
                                    handleCopyClick={(a) => this.props.handleCopyClick(a, "draft")}
                                    handleNotesClick={(a) => this.props.handleNotesClick(a, "draft")}>
                                    <TableButton id={`TableButton-${pt.id}`} icon="icon-config-layouts" title="Opções" />
                                </PopoverForm>
                                {closable ? <a className="pst_a_delete" onClick={(e) => this.props.handleDeleteClick(pt, "draft")}>X</a> : null}
                                <span className="pst_span" title={pt.code} onDoubleClick={(e) => this.props.onDoubleClickTrip(pt.id, e)}>{pt.code}</span>
                            </th>
                        );
                    }
                }
                else {
                    tablePathTrips.push(
                        <th className="pst_th_trips" title={pt.code} key={`pathTrip-${i}`}>
                            {closable && "object" !== typeof pt.code ? <a className="pst_a_delete" onClick={(e) => this.props.handleDeleteClick(pt, "draft")}>X</a> : null}
                            <input className="pst_input" type="text" value={pt.code} placeholder="Nome" onChange={(e) => this.props.onChangeTripName(pt.id, e)} />
                        </th>
                    );
                }

                pt.passings.forEach((pass) => {
                    if (pass.pathStopId !== undefined) {
                        if (tablePassings[pass.pathStopId]) {
                            tablePassings[pass.pathStopId].push(
                                <td className="pst_td" key={`passings-${pass.id}`}>
                                    <input className="pst_input text-align-center"
                                        type="text"
                                        tabIndex={tabIndex + pass.pathStopOrder}
                                        value={pass.formatedHour !== ":" && pass.formatedHour !== "undefined:NaN" ? pass.formatedHour : ""}
                                        placeholder="HH:mm"
                                        onChange={(e) => this.props.onChangePassValue(pass.id, e)} />
                                    {selectedPassing !== undefined && selectedPassing.id === pass.id ? <Button className="propagate-btn" onClick={() => this.props.onClickPropagateBtn()}>P</Button> : null}
                                </td>
                            );
                        } else {
                            tablePassings[pass.pathStopId] = [
                                <td className="pst_td" key={`passings-${pass.id}`}>
                                    <input className="pst_input text-align-center"
                                        type="text"
                                        tabIndex={tabIndex + pass.pathStopOrder}
                                        value={pass.formatedHour !== ":" && pass.formatedHour !== "undefined:NaN" ? pass.formatedHour : ""}
                                        placeholder="HH:mm"
                                        onChange={(e) => this.props.onChangePassValue(pass.id, e)} />
                                    {selectedPassing !== undefined && selectedPassing.id === pass.id ? <Button className="propagate-btn" onClick={() => this.props.onClickPropagateBtn()}>P</Button> : null}
                                </td>
                            ];
                        }
                    }
                });

                tabIndex += pathSelectedPathStops.length;
            }
        });

        tablePathTrips.push(
            <th className="pst_th_insert" key={`pathTrip-new`}>
                <Button bsSize="small" className="pull-left table-btn" onClick={() => this.props.handleCreateClick()}>
                    <div className="icon-plus icon-img pst_a_insert"></div>
                </Button>
            </th>
        );

        return (
            <Row className="pst-table-wrapper-row">
                <Col className="pst-col-pst-table" sm={12}>
                    <Table responsive striped hover>
                        <thead>
                            <tr className="pst_tr_stops_header">
                                <th className="pst_th_stops">PARAGEM</th>
                                {tablePathTrips}
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderPathStops(pathSelectedPathStops, tablePassings)}
                        </tbody>
                    </Table >
                </Col>
            </Row>
        );
    }

    renderSchedules() {
        const { viewAllSchedules } = this.state;
        const { pathSelected } = this.props;

        if (undefined === pathSelected) {
            return null;
        }

        const { loadingPathStops } = this.props;

        if (loadingPathStops) {
            return (<LoadingSpinner />);
        }

        const { schedules, scheduleSelected } = this.props;
        let schedulesToRender = viewAllSchedules ?
            schedules :
            schedules.filter(s => s.paths.filter(p => p.id === pathSelected.id).length > 0);

        if (!schedulesToRender.includes(scheduleSelected) && undefined !== scheduleSelected) {
            schedulesToRender.push(scheduleSelected);
        }

        return (
            <FormGroup controlId="formSchedules">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Horário</ControlLabel>
                    </Col>
                    <Col sm={9}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um horário..."
                            noOptionsMessage={() => "Sem Horários Configurados"}
                            onChange={(e) => this.props.handleScheduleSelected(e)}
                            options={schedulesToRender}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.name}
                            value={undefined === scheduleSelected ? null : scheduleSelected}
                        />
                    </Col>
                    <Col sm={2}>
                        <label>
                            <Toggle className="comparison-toggle"
                                checked={viewAllSchedules}
                                icons={false}
                                onChange={() => this.toggleViewAllSchedules()} />
                            <span>VER TODOS OS HORÁRIOS DISPONÍVEIS</span>
                        </label>
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderPaths() {
        const { linePaths } = this.props;

        if (0 === linePaths.length) {
            return null;
        }

        const { loadingPaths } = this.props;

        if (loadingPaths) {
            return (<LoadingSpinner />);
        }

        const { pathSelected } = this.props;

        return (
            <FormGroup controlId="formPaths">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Percurso</ControlLabel>
                    </Col>
                    <Col sm={11}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um percurso..."
                            noOptionsMessage={() => "Sem Percursos Configurados"}
                            onChange={(e) => this.props.handlePathSelected(e)}
                            options={linePaths}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.code}
                            value={undefined === pathSelected ? null : pathSelected}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    render() {
        const { lines, lineSelected } = this.props;

        return (
            <Grid fluid>
                <FormGroup className="margin-top-15" controlId="formLine">
                    <Row className="row-dropdown">
                        <Col sm={1}>
                            <ControlLabel className="control-label-dropdown">Linha</ControlLabel>
                        </Col>
                        <Col sm={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma linha..."
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.props.handleLineSelected(e)}
                                options={lines.sort(SortHelper.defaultLineSorter)}  // ascending order
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={lineSelected}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderPaths()}
                {this.renderSchedules()}
                {this.renderTable()}
            </Grid>
        );
    }
}
